export type RiskLevel = 'low' | 'medium' | 'high' | 'veryHigh';

export const getRiskLevel = (likelihood: number, impact: number): RiskLevel => {
  if (impact === 1) return 'low';
  if (likelihood === 1 && impact === 2) return 'low';
  if (
    (likelihood === 1 && impact === 3) ||
    (likelihood === 2 && (impact === 2 || impact === 3)) ||
    (likelihood === 3 && impact === 2)
  ) return 'medium';
  if (
    (likelihood === 1 && impact === 4) ||
    (likelihood === 2 && impact === 4) ||
    (likelihood === 3 && impact === 3) ||
    ((likelihood === 4 || likelihood === 5) && impact === 2)
  ) return 'high';
  return 'veryHigh';
};

export const LEVEL_LABELS: Record<RiskLevel, string> = {
  low: 'ต่ำ',
  medium: 'ปานกลาง',
  high: 'สูง',
  veryHigh: 'สูงมาก',
};

export const getRiskLevelLabel = (likelihood: number, impact: number): string => {
  return LEVEL_LABELS[getRiskLevel(likelihood, impact)];
};

export const LEVEL_COLORS: Record<RiskLevel, { bg: string; text: string }> = {
  low: { bg: '#2ECC71', text: 'white' },
  medium: { bg: '#F4D03F', text: 'black' },
  high: { bg: '#E59834', text: 'black' },
  veryHigh: { bg: '#D9383A', text: 'white' },
};

export const getRiskLevelStyle = (likelihood: number, impact: number): { bg: string; text: string } => {
  return LEVEL_COLORS[getRiskLevel(likelihood, impact)];
};
